import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  ClockCircleOutlined,
  CloseCircleOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { InputNumber, Popover } from "antd";
import classNames from "classnames";
import moment from "moment";

import AppButton from "components/button";

import styles from "./styles.module.scss";

const AppTimePicker = props => {
  const {
    value,
    disabled,
    onChange,
    style,
    className,
    placeholder = "",
  } = props;

  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isAM, setIsAM] = React.useState(moment(value).hours() < 12);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const hours =
    !!value && value !== ""
      ? moment(value).hours() >= 12
        ? moment(value).hours() - 12
        : moment(value).hours()
      : 0;
  const minutes = !!value && value !== "" ? moment(value).minutes() : 0;

  const handleSelecteHours = hoursValue => {
    const time = moment(new Date())
      .hours(isAM ? hoursValue : hoursValue + 12)
      .minutes(minutes)
      .format("YYYY/MM/DD HH:mm");
    onChange && onChange(time);
  };
  const handleSelectMinutes = minutesValue => {
    const time = moment(value && value !== "" ? value : new Date())
      .hours(hours)
      .minutes(minutesValue ? minutesValue : 0)
      .format("YYYY/MM/DD HH:mm");
    onChange && onChange(time);
  };

  useEffect(() => {
    if (hours) {
      handleSelecteHours(hours);
    }
  }, [isAM]);

  return (
    <div
      className={classNames({
        [styles.wrapSelect]: true,
        [className]: !!className,
      })}
      style={style}
    >
      <div
        className={classNames({
          [styles.disabled]: disabled,
          [styles.input]: true,
        })}
        aria-describedby={id}
      >
        <ClockCircleOutlined
          className="icon clock-icon"
          onClick={handleClick}
        />
        <CloseCircleOutlined
          className="icon remove-icon"
          onClick={() => {
            handleSelecteHours(0);
            handleSelectMinutes(0);
            onChange(
              moment(new Date()).hours(0).minutes(0).format("YYYY/MM/DD HH:mm")
            );
          }}
        />
        <span className={styles.value} onClick={handleClick}>
          {value && value !== ""
            ? moment(value).format("HH:mm")
            : t(placeholder)}
        </span>
      </div>
      <Popover
        id={id}
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className={styles.selectBox}>
          <div
            styles={{
              flex: "1 0 0px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              className={classNames({
                "wrap-icon": true,
                [styles.disabled]: hours === 11,
              })}
              onClick={() => handleSelecteHours(hours + 1)}
            >
              <UpOutlined />
            </div>
            <InputNumber
              onChange={value => {
                handleSelecteHours(value);
              }}
              value={hours}
              autoComplete="off"
              min={0}
              max={11}
              className={styles.inputTime}
            />
            <div
              className={classNames({
                "wrap-icon": true,
                [styles.disabled]: hours === 0,
              })}
              onClick={() => handleSelecteHours(hours - 1)}
            >
              <DownOutlined />
            </div>
          </div>
          <div
            styles={{ padding: "10px", display: "flex", alignItems: "center" }}
          >
            {":"}
          </div>
          <div
            styles={{
              flex: "1 0 0px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              className={classNames({
                "wrap-icon": true,
                [styles.disabled]: minutes === 59,
              })}
              onClick={() => handleSelectMinutes(minutes + 1)}
            >
              <UpOutlined />
            </div>
            <InputNumber
              onChange={value => {
                handleSelectMinutes(value);
              }}
              value={minutes}
              autoComplete="off"
              min={0}
              max={59}
              className={styles.inputTime}
            />
            <div
              className={classNames({
                "wrap-icon": true,
                [styles.disabled]: minutes === 0,
              })}
              onClick={() => handleSelectMinutes(minutes - 1)}
            >
              <DownOutlined />
            </div>
          </div>
          <div
            styles={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              flex: "1 0 auto",
              gridRowGap: 4,
            }}
          >
            <AppButton
              label={t("label.am")}
              color="blueLighten"
              varient={isAM ? "contained" : "outlined"}
              onClick={() => setIsAM(true)}
            />
            <AppButton
              label={t("label.pm")}
              color="blueLighten"
              varient={isAM ? "outlined" : "contained"}
              onClick={() => setIsAM(false)}
            />
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default AppTimePicker;
